import { useEffect, useState } from "react"
import Loader from "../../components/Loader"
import { getPlayer } from "../../services/players.services"
import { NavLink, Outlet, useParams } from "react-router-dom"
import { toast } from "react-toastify"
import Header from "../../components/Header"
import { useAppDispatch, useAppSelector } from "../../store/store"
import { setPlayer } from "../../store/features/playerPageSlice"
import { deleteToken } from "../../store/features/tokenSlice"

const NavigationItem: React.FC<{ to?: string, title: string }> = ({ to = "/", title }) => {
    return <NavLink end className={({ isActive }) => `rounded-t-lg ${isActive ? "text-zinc-700 bg-white" : "bg-transparent text-white"} px-5 py-2`} to={to}>{title}</NavLink>
}

const PlayerNavigation = () => {
    const playerLogged = useAppSelector(state => state.player)
    const player = useAppSelector(state => state.playerPage)
    return (
        <div className="px-5 md:px-32 flex items-center gap-5 bg-[#c63631] overflow-x-auto">
            <NavigationItem to={`/p/${player.name}`} title="General" />
            <NavigationItem to={`/p/${player.name}/awards`} title="Premios" />
            <NavigationItem to={`/p/${player.name}/teams`} title="Equipos" />
            {player?.id === playerLogged.id && <NavigationItem to={`/p/${player.name}/wallet`} title="Billetera" />}
            {player?.id === playerLogged.id && <NavigationItem to={`/p/${player.name}/edit`} title="Editar" />}
        </div>
    )
}

const PlayerPage = () => {
    const { playerName } = useParams()
    const playerLogged = useAppSelector(state => state.player)
    const player = useAppSelector(state => state.playerPage)
    const [loading, setLoading] = useState<boolean>(true)

    const dispatch = useAppDispatch()


    useEffect(() => {
        getPlayer({ name: playerName as string })
            .then((res) => {
                dispatch(setPlayer(res.data.payload.player))
            })
            .catch(() => toast.error("Ha ocurrido un error"))
            .finally(() => setLoading(false))
    }, [])


    if (loading && !player) return <Loader />

    if (!loading && !player) return (
        <div>
            <div className="flex flex-col gap-5 px-32 py-10 bg-[#c63631]">
                <p className="text-white font-extrabold uppercase text-4xl">Jugador no encontrado</p>
            </div>
        </div>
    )

    return (
        <div className="flex flex-col">
            <Header className="flex flex-col gap-5 bg-[#c63631]">
                <div className="flex items-center gap-5">
                    <p className="text-white font-extrabold text-4xl">{player?.name}</p>
                    {player?.country && <img className="bg-white" src={`https://flagsapi.com/${player?.country?.split(",")[0]}/flat/32.png`} alt="flag-country"></img>}
                    {player?.gender && <p className="text-3xl text-white font-bold">{player.gender === 'male' ? "♂️" : "♀️"}</p>}
                </div>
                {player?.description && <p className="text-white">{player?.description}</p>}
                {player?.id === playerLogged.id && <button className="text-white font-bold uppercase self-start" onClick={() => dispatch(deleteToken())}>Cerrar Sesión</button>}
            </Header>
            <PlayerNavigation />

            <Outlet />
        </div>
    )
}

export default PlayerPage